import { useCallback } from "react";
import { Api } from "../../common/service/Api";
import { useDataRequest } from "../../common/hooks/api";
import { OrganizationPublicId } from "../../common/service/server/Types";
import { ServiceAccountInboxMessageDto } from "../../common/service/server/dto/ServiceAccountInboxMessageDto";
import { ServiceAccountSetupDto } from "../../common/service/server/dto/ServiceAccountSetupDto";

/** The organization's Ramsay service account inbox, newest message first. */
export const useServiceAccountInbox = (organizationId: OrganizationPublicId, enabled = true) => {
  const api = useCallback(
    () => Api.serviceAccountInbox.getMessages(organizationId),
    [organizationId],
  );

  return useDataRequest<ServiceAccountInboxMessageDto[]>({
    queryKey: enabled ? ["ramsay-service-account-inbox", organizationId] : [],
    api,
    messages: { defaultError: "Unable to load the service account inbox." },
    notReady: !enabled,
  });
};

/** The organization's data recipients with their Ramsay service account addresses. */
export const useServiceAccountSetup = (organizationId: OrganizationPublicId, enabled = true) => {
  const api = useCallback(
    () => Api.serviceAccountInbox.getServiceAccounts(organizationId),
    [organizationId],
  );

  return useDataRequest<ServiceAccountSetupDto>({
    queryKey: enabled ? ["ramsay-service-accounts", organizationId] : [],
    api,
    messages: { defaultError: "Unable to load service accounts." },
    notReady: !enabled,
  });
};
